import { Layout } from "@tm/morpheus"

export default class NoLayout extends Layout {
    render() {
        return this.props.children[0]
    }
}
